module.exports = __webpack_public_path__ + "img/header-weddingRingsPlain@2x.0aefbcb.jpg";